import Murmur from '@icij/murmur'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import PortalVue from 'portal-vue'
import { BootstrapVue } from 'bootstrap-vue'
import { library as fortawesome } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faSearchPlus, faShareAlt, faTh, faTimes } from '@fortawesome/free-solid-svg-icons'
import VueAnalytics from 'vue-analytics'

import routes from './router'
import guards from './router/guards'
import messages from './i18n'
import store from './store'
import './main.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Murmur)
Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(PortalVue)

Murmur.config.set('project.name', 'Pandora Papers — Power Players')
Murmur.config.set('app.name', 'Pandora Papers — Power Players')
Murmur.config.set('app.home', 'https://www.icij.org/investigations/pandora-papers/')

// Register icons
fortawesome.add(faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faSearchPlus, faShareAlt, faTh, faTimes)

const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView'),
  h('PortalTarget', { props: { name: 'overlay' } })
])

const config = Murmur.config
const i18n = new VueI18n({ locale: 'en', messages })
const mode = 'history'
const router = guards({ router: new VueRouter({ routes, mode }), i18n, config })

Vue.use(VueAnalytics, {
  id: 'UA-3383794-15',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: '/investigations/pandora-papers/power-players/' + route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

new Vue({ router, render, i18n, store }).$mount('#app')
